import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { payrollAPI } from '../../services/api';
import { getErrorMessage } from '../../utils/errorHandler';

export const fetchPayrolls = createAsyncThunk('payroll/fetchAll', async (params, { rejectWithValue }) => {
  try {
    const response = await payrollAPI.fetchPayrolls(params);
    return response.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to fetch payrolls'));
  }
});

export const processPayroll = createAsyncThunk('payroll/process', async (data, { rejectWithValue }) => {
  try {
    const response = await payrollAPI.processPayroll(data);
    return response.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to process payroll'));
  }
});

export const processAllPayroll = createAsyncThunk('payroll/processAll', async (data, { rejectWithValue }) => {
  try {
    const response = await payrollAPI.processAllPayroll(data);
    return response.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to process payroll'));
  }
});

export const createAllowance = createAsyncThunk('payroll/createAllowance', async (data, { rejectWithValue }) => {
  try {
    const response = await payrollAPI.createAllowance(data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to create allowance'));
  }
});

export const createDeduction = createAsyncThunk('payroll/createDeduction', async (data, { rejectWithValue }) => {
  try {
    const response = await payrollAPI.createDeduction(data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to create deduction'));
  }
});

export const fetchPayslip = createAsyncThunk('payroll/fetchPayslip', async (id, { rejectWithValue }) => {
  try {
    const response = await payrollAPI.fetchPayslip(id);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to fetch payslip'));
  }
});

const initialState = {
  payrolls: [],
  currentPayroll: null,
  currentPayslip: null,
  payslips: [],
  summary: null,
  loading: false,
  error: null,
};

const payrollSlice = createSlice({
  name: 'payroll',
  initialState,
  reducers: {
    clearPayrollError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPayrolls.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchPayrolls.fulfilled, (state, action) => { state.loading = false; state.payrolls = action.payload.data || action.payload; })
      .addCase(fetchPayrolls.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(processPayroll.fulfilled, (state, action) => { state.payrolls.unshift(action.payload); })
      .addCase(createAllowance.fulfilled, (state, action) => { state.currentPayroll = action.payload; })
      .addCase(createDeduction.fulfilled, (state, action) => { state.currentPayroll = action.payload; })
      .addCase(fetchPayslip.fulfilled, (state, action) => { state.currentPayslip = action.payload; });
  },
});

export const { clearPayrollError } = payrollSlice.actions;
export default payrollSlice.reducer;
